import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AccountPage from './AccountPageComponent';
import actions from './actions';

const allActions = { ...actions };

const mapStateToProps = (state, props) => ({
  ...props,
  account: state.account,
  runtimeConfig: props.runtimeConfig,
});

const mapDispatchToProps = (dispatch) => ({ actions: bindActionCreators(allActions, dispatch) });

export default connect(mapStateToProps, mapDispatchToProps)(AccountPage);
